import React, { useState } from 'react';
import { scrapeUrl, ScrapeResponse } from '../../services/editor';
import Button from '../Button';
import './NewsArticleScraper.css';

interface NewsArticleScraperProps {
    onArticleScraped?: (articleData: ScrapeResponse) => void;
    initialUrl?: string;
}

const NewsArticleScraper: React.FC<NewsArticleScraperProps> = ({ onArticleScraped, initialUrl }) => {
    const [url, setUrl] = useState(initialUrl || '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleScrape = async () => {
        if (!url.trim()) {
            setError('Veuillez entrer une URL');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const data = await scrapeUrl(url);
            onArticleScraped?.(data);
        } catch (err) {
            setError('Erreur lors du scraping de l\'URL');
            console.error('Scraping error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setUrl('');
        setError(null);
    };

    return (
        <div className="NewsArticleScraper">
            <div className="scraper-form">
                <input
                    type="url"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder="URL de l'article de presse..."
                    disabled={loading}
                    className="scraper-input"
                />
                <Button 
                    onClick={handleScrape} 
                    disabled={!url.trim()}
                    loading={loading}
                    size="small"
                    variant="primary"
                >
                    Récupérer
                </Button>
                {url && (
                    <Button 
                        onClick={handleClear}
                        size="small"
                        variant="secondary"
                    >
                        Effacer
                    </Button>
                )}
            </div>

            {error && (
                <div className="scraper-error">
                    {error}
                </div>
            )}
        </div>
    );
};

export default NewsArticleScraper;
